/**
 * Open forms with unsaved changes (roadmap 3.1: the service worker never swaps versions under a dirty
 * form). The update prompt asks every registered form to save its draft before it reloads the page.
 */
export type DirtyForm = { isDirty(): boolean; flush(): Promise<void> };

const forms = new Set<DirtyForm>();

export function registerForm(f: DirtyForm): () => void {
  forms.add(f);
  return () => forms.delete(f);
}

export const anyDirty = () => [...forms].some((f) => f.isDirty());

export async function flushAll(): Promise<void> {
  await Promise.allSettled([...forms].map((f) => f.flush()));
}
